import {OutsideAnnouncementControlled} from '@gaia/components/header-ui/OutsideAnnouncement';
import {useBanner} from '@gaia/hooks/useBanner';

import classes from './Map.module.css';

export function MapAnnouncement() {
    const banner = useBanner();

    if (!banner?.message) return null;

    return (
        <div className={classes.announcement}>
            <OutsideAnnouncementControlled
                message={banner.message}
                dismissable={true}
                localStorageKey={banner.hash}
            />
        </div>
    );
}
